module.exports = __webpack_public_path__ + "81a7bc75b1ee9bf2742908d6632e3585.jpg";